<template>
<div>
  <el-table :data="specificationsList" style="width: 100%">
    <el-table-column label="产品图片" align="center">
      <template slot-scope="scope">
        <img :src="scope.row.coverImages[0] ? scope.row.coverImages[0].url : ''" alt="" />
      </template>
    </el-table-column>
    <el-table-column prop="name" label="名称/型号" align="center">
    </el-table-column>
    <el-table-column label="参数" align="center">
      <template slot-scope="scope" v-if="scope.row.params">
          <span v-for="(item,index) in scope.row.params" :key="index" class="params_span">{{ item }}
              <br v-if="(index+1)%2==0"/>
          </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="czbox">
          <div>
            <p @click="joinCompare(scope.row)" style="margin-bottom: 20px"><i class="el-icon-plus"></i> 加入对比</p>
            <p @click="getInquiry(scope.row.uuid)"><i class="el-icon-plus"></i> 立即询价</p>
          </div>
          <el-button type="primary" @click="getProdutDetails(scope.row.uuid)">详情</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <inquiry ref="inquireRef"></inquiry>
</div>
</template>

<script>
// 询价
import { mixins } from "../mixin/index.js"
import inquiry from "./inquiry"
export default {
  props:{
    specificationsList:Array,
  },
  mixins: [mixins],
  components: {
    inquiry
  },
  data() {
    return {};
  },
  methods: {
    getProdutDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "productDetails",
      });
      window.open(routeData.href+'?uuid='+uuid, "_blank");
    },
    getInquiry(uuid) {
      if (!this.$store.state.isLogin) {
        this.$message.warning('请先登录');
        this.$router.push({
          name: "login",
        });
        return false;
      } else {
        this.$refs.inquireRef.init(uuid);
      }
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table--fit {
  border: none !important;
}
/deep/.el-table th.el-table__cell {
  background-color: #F9F9F9;
  border: none !important;
}
img {
  width: 170px;
  height: 126px;
}
.params_span {
  width:50%;
  margin-bottom:38px;
  display:inline-block;
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
  &:nth-last-child(2) {
    margin-bottom: 0;
  }
}
.csbox {
  display: flex;
  flex-wrap: wrap;
  p {
    width: 50%;
  }
}
.czbox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  p {
    color: #2d50a1;
    cursor: pointer;
    width: 106px;
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    border: 1px solid #169999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/components/productCom.vue